<ion-accordion-group [value]="initiallyActiveItem()">
  @for (item of items(); track item; let index = $index) {
    <ion-accordion
      [value]="item.reference ?? index"
      class="parkour-accordion"
      toggleIconSlot="start"
    >
      <button
        class="flex items-center gap-x-2 py-4 w-full hover:bg-n-200 focus:bg-n-200 transition-colors text-left"
        slot="header"
        [attr.id]="item.reference ? 'accordion-' + item.reference : ''"
      >
        <parkour-icon class="ion-accordion-toggle-icon text-s-100" name="chevron-right" />
        @if (titleTemplate(); as title) {
          <p class="typo-body variant-body-fat">
            <ng-container *ngTemplateOutlet="title; context: { item }"></ng-container>
          </p>
        }
      </button>
      <div slot="content">
        @if (contentTemplate(); as content) {
          <div class="pl-6 pb-4 pt-2">
            <ng-container *ngTemplateOutlet="content; context: { item }"></ng-container>
          </div>
        }
      </div>
    </ion-accordion>
  }
</ion-accordion-group>
